export class BasePanel {
  constructor(manager, visible = true) {
    this.manager = manager;
    this.vrManager = manager.vrManager;
    this.uilib = this.vrManager.uiLib;
    this._visible = visible;
    this.enabled = this._visible;

    this.uiElements = [];
    this.init();
  }

  init() {}

  hide() {
    for (var i = 0; i < this.uiElements.length; i++) {
      if (this.uiElements[i].hide) {
        this.uiElements[i].hide();
      }
    }
  }

  show() {
    for (var i = 0; i < this.uiElements.length; i++) {
      if (this.uiElements[i].show) {
        this.uiElements[i].show();
      }
    }
    this.enabled = true;
  }

  closePanel() {
    this.hide();
    this.enabled = false;
  }
}
